export default __webpack_public_path__ + "static/media/neft-rtgs-icon.cb68a754.svg";